import { share } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Config } from '../config.const';
import { Injectable } from '@angular/core';

export interface ICatastoItem {
	codcatasto: string;
}

export interface INazione extends ICatastoItem {
	nome: string;
}

export interface IComune extends ICatastoItem {
	citta: string;
	pr: string;
	cap: string;
}

export interface IIndirizzo {
	citta: string;
	cap: string;
	pr: string;
	nome: string;
	tipo: string;
	details?: string;
}

@Injectable()
export class Luoghi {
	public readonly nazioni: Observable<INazione[]>;
	public readonly comuni: Observable<IComune[]>;

	constructor(private readonly $http: HttpClient) {
		this.nazioni = $http.get<INazione[]>(`${Config.baseURL}/static/anagrafica/nazioni`).pipe(share());
		this.comuni = $http.get<IComune[]>(`${Config.baseURL}/static/anagrafica/comuni`).pipe(share());
	}

	searchVie(term: string): Observable<IIndirizzo[]> {
		const params = new HttpParams().set("search", term);

		return this.$http.get<IIndirizzo[]>(
			`${Config.baseURL}/cerca/vie`,
			{ params }
		).pipe(
			share()
		);
	}
}


// WEBPACK FOOTER //
// ./src/app/model/luoghi.ts